var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAppointment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-time-limit 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.875 4.0625H14",
    stroke: "#666666",
    strokeWidth: 1.21,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.5 6.3125H11.375",
    stroke: "#666666",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.5 6.3125H4.25",
    stroke: "#666666",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.5 8.5625H9.4625",
    stroke: "#666666",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.5 8.5625H4.25",
    stroke: "#666666",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.5 10.8125H8",
    stroke: "#666666",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M3.5 10.8125H4.25",
    stroke: "#666666",
    strokeWidth: 1.21,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M0.875 5.375V2.5625C0.875 1.7375 1.55 1.0625 2.375 1.0625H12.5C13.325 1.0625 14 1.7375 14 2.5625V6.125",
    stroke: "#666666",
    strokeWidth: 1.21,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M5.4875 13.4375H2.375C1.55 13.4375 0.875 12.7625 0.875 11.9375V7.4375",
    stroke: "#666666",
    strokeWidth: 1.21,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M11.5625 7.8125C13.5125 7.8125 15.125 9.425 15.125 11.375C15.125 13.325 13.5125 14.9375 11.5625 14.9375C9.6125 14.9375 8 13.325 8 11.375C8 10.85 8.1125 10.3625 8.3 9.9125",
    stroke: "#666666",
    strokeWidth: 1.21,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.5625 7.8125V8.9375",
    stroke: "#666666",
    strokeWidth: 1.21,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M11.5625 11.375L11 10.8125",
    stroke: "#666666",
    strokeWidth: 1.21,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppointment);
export default __webpack_public_path__ + "static/media/iconAppointment.b802f5405a7343dc99d79185609b15cc.svg";
export { ForwardRef as ReactComponent };